// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"5c9048ae","453":"08dfda53","613":"c3943843"}[chunkId] + ".chunk.js";
};